import React from "react";
import { XIcon } from "./icons/FeatherIcons";
import { type ChatMessage, type User } from "../types";
import { toJsDate } from "../utils/toJsDate";

interface MessageStatusModalProps {
  message: ChatMessage;
  participants: User[];
  currentUserId: string;
  onClose: () => void;
}

const MessageStatusModal: React.FC<MessageStatusModalProps> = ({
  message,
  participants,
  currentUserId,
  onClose,
}) => {
  // Format timestamp
  const formatTimestamp = (timestamp: string | undefined) => {
    if (!timestamp) return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleString("en-US", {
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    });
  };

  // Get delivery and read timestamps
  const deliveredAt = message.deliveredAt
    ? formatTimestamp(message.deliveredAt)
    : "Not delivered";
  const readAt = message.readAt ? formatTimestamp(message.readAt) : "Not read";

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4"
      tabIndex={-1}
      onPointerDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onTouchStart={(e) => {
        //e.preventDefault();
        e.stopPropagation();
      }}
      onTouchEnd={(e) => {
        //e.preventDefault();
        e.stopPropagation();
      }}
      onTouchCancel={(e) => {
        //e.preventDefault();
        e.stopPropagation();
      }}
      onContextMenu={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl max-w-md w-full max-h-[80vh] overflow-hidden"
        tabIndex={-1}
        onPointerDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        onTouchStart={(e) => {
          //e.preventDefault();
          e.stopPropagation();
        }}
        onTouchEnd={(e) => {
          //e.preventDefault();
          e.stopPropagation();
        }}
        onTouchCancel={(e) => {
          //e.preventDefault();
          e.stopPropagation();
        }}
        onContextMenu={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-200">
          <h3 className="text-lg font-semibold text-gray-900">
            Message Status
          </h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            aria-label="Close"
          >
            <XIcon className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-4 space-y-4">
          {/* Message preview */}
          <div className="bg-gray-50 rounded-lg p-3 border border-gray-200">
            <p className="text-sm text-gray-600 mb-1 font-medium">Message:</p>
            <p className="text-sm text-gray-900 break-words">{message.text}</p>
          </div>

          {/* Sent time */}
          <div className="flex items-center justify-between py-2 border-b border-gray-100">
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 bg-gray-400 rounded-full"></div>
              <span className="text-sm font-medium text-gray-700">Sent</span>
            </div>
            <span className="text-sm text-gray-600">
              {formatTimestamp(message.timestamp)}
            </span>
          </div>

          {/* // Delivered time
                    <div className="flex items-center justify-between py-2 border-b border-gray-100">
                        <div className="flex items-center gap-2">
                            <div className={`w-2 h-2 rounded-full ${message.deliveredTo && message.deliveredTo.length > 0 ? 'bg-gray-400' : 'bg-gray-300'}`}></div>
                            <span className="text-sm font-medium text-gray-700">Delivered</span>
                        </div>
                        <span className="text-sm text-gray-600">{deliveredAt}</span>
                    </div> */}

          {/* Read time */}
          <div className="flex items-center justify-between py-2">
            <div className="flex items-center gap-2">
              <div
                className={`w-2 h-2 rounded-full ${message.readBy && message.readBy.length > 0 ? "bg-blue-500" : "bg-gray-300"}`}
              ></div>
              <span className="text-sm font-medium text-gray-700">Read</span>
            </div>
            <span className="text-sm text-gray-600">{readAt}</span>
          </div>

          {/* Info note */}
          <div className="bg-blue-50 rounded-lg p-3 mt-4">
            <p className="text-xs text-blue-700">
              💡 Timestamps show when the first recipient received or read your
              message.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageStatusModal;
